import { createReducer, on } from '@ngrx/store';
import { CombinationFilterValues } from '@shared/interfaces/combination/combination-filters/combination-filters.interface';
import { PageableCombination } from '@shared/interfaces/combination/pageable-combination.interface';
import { Page } from '@shared/interfaces/pagination/page.interface';

import * as adminCombinationsActions from './admin-combinations.actions';
import { loadFilters, loadTableDataAndFilters } from './admin-combinations.actions';

export const adminCombinationsFeatureKey = 'adminCombinations';

export interface AdminCombinationsState {
  filters: CombinationFilterValues;
  page: Page<PageableCombination>;
  loading?: boolean;
}

export const initialState: AdminCombinationsState = {
  filters: {},
  page: { content: [] as Array<PageableCombination> } as Page<PageableCombination>,
  loading: false
};

export const adminCombinationsReducer = createReducer<AdminCombinationsState>(
  initialState,
  on(
    loadTableDataAndFilters.loadTableAndFilters,
    loadFilters.loadFilters,
    (state: AdminCombinationsState) => ({
      ...state,
      loading: true
    })
  ),
  on(
    loadTableDataAndFilters.loadTableAndFiltersSuccess,
    (
      state: AdminCombinationsState,
      data: {
        page: Page<PageableCombination>;
        filters: CombinationFilterValues;
      }
    ) => ({
      ...state,
      filters: data.filters,
      page: data.page,
      loading: false
    })
  ),
  on(
    loadFilters.loadFiltersSuccess,
    (state: AdminCombinationsState, data: { filters: CombinationFilterValues }) => ({
      ...state,
      filters: data.filters,
      loading: false
    })
  ),
  on(loadTableDataAndFilters.cleanupTableAndFilters, (state: AdminCombinationsState) => ({
    ...state,
    loading: false
  })),
  on(
    adminCombinationsActions.loadingAction,
    (state: AdminCombinationsState, data: { loading?: boolean }) => ({
      ...state,
      loading: data.loading
    })
  )
);
